import { useDemoMode } from '../demoMode';
import { FlaskConical } from 'lucide-react';

/** Bandeau orange affiché en haut de toutes les pages CRM quand le mode Démo est activé */
export default function DemoModeBanner() {
  const [demo, setDemo] = useDemoMode();
  if (!demo) return null;
  return (
    <div className="sticky top-0 z-40 bg-gradient-to-r from-orange-500/95 to-amber-500/95 text-slate-950 px-4 py-1.5 flex items-center justify-center gap-3 text-xs font-semibold shadow-md">
      <FlaskConical size={14} strokeWidth={2.5} />
      <span>MODE DÉMO ACTIF — Vous travaillez sur des données de test isolées</span>
      <button
        onClick={() => setDemo(false)}
        className="ml-2 px-2 py-0.5 bg-slate-950/20 hover:bg-slate-950/40 rounded-full text-[10px] font-bold uppercase tracking-wider transition-colors"
      >
        Revenir au réel
      </button>
    </div>
  );
}
